import { Pipe, PipeTransform } from '@angular/core';
import { PaymentType } from '../enums';

export const PaymentTypeToDisplay: Record<PaymentType, string> = {
  [PaymentType.AdditionalUsers]: 'M365/Google Backup. Additional Users',
  [PaymentType.FirstSubscriptionActivated]: 'M365/Google Backup',
  [PaymentType.SharePoint]: 'M365/Google Backup. SharePoint',
  [PaymentType.StorageChange]: 'Storage Update',
  [PaymentType.StorageAndTraffic]: 'M360 Storage',
  [PaymentType.SubscriptionUpdated]: 'M365/Google Backup',
  [PaymentType.TeamDrive]: 'M365/Google Backup. Shared Drives'
};

@Pipe({
  name: 'paymentTypeToDisplay',
  pure: true
})
export class PaymentTypeToDisplayPipe implements PipeTransform {
  transform(value: PaymentType): string {
    if (!value) return '';

    return PaymentTypeToDisplay[value] ?? '';
  }
}
